import gql from 'graphql-tag';

export const HAS_ISSUE_ON_SOCIAL_ACCOUNT = gql`
  query HasIssueOnSocialAccount {
    hasIssueOnSocialAccount
  }
`;
